import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

export enum AppProviderField {
  provideName = 'provideName'
}

export interface AppProviderForm {
  [AppProviderField.provideName]: string;
}

const useAddProviderForm = () => {
  const methods = useForm<AppProviderForm>({
    resolver: getValidationResolver({
      [AppProviderField.provideName]: VALIDATORS.REQUIRED_STRING,
    }),
  });

  return { methods };
};

export default useAddProviderForm;
